import SectionStandardSignPostCards, {
	type SectionStandardSignPostCardsProps,
} from "../SectionStandardSignPostCards/SectionStandardSignPostCards";

import React from "react";

export const SectionSuccessStoryCards: React.FC<
	SectionStandardSignPostCardsProps
> = ({ ...props }) => (
	<SectionStandardSignPostCards {...props} isSuccessStories={true} />
);

export default SectionSuccessStoryCards;
